import React from 'react';
import './HomeVideo.css';

const HomeVideo = () => {
  return (
    <div className="video-container">
      <video
        className="video"
        src="https://videos.pexels.com/video-files/3141210/3141210-uhd_2560_1440_25fps.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
};

export default HomeVideo;
